module.exports = __webpack_public_path__ + "img/xymox.8de901c1.jpg";